import { DashboardOutlined } from "@ant-design/icons";
import PeopleOutlinedIcon from "@mui/icons-material/PeopleOutlined";
import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import { FormattedMessage, useIntl } from "react-intl";
const userManagmentItems = () => {
  const icons = {
    DashboardOutlined,
    PeopleOutlinedIcon,
    BusinessOutlinedIcon,
    GroupsOutlinedIcon,
  };

  const userItems = {
    id: "group-dashboards",
    title: (
      <FormattedMessage id="Accounts and Roles">
        {(text) => (
          <span style={{ fontSize: "14px", fontWeight: "normal" }}>{text}</span>
        )}
      </FormattedMessage>
    ),
    type: "group",
    icon: icons.DashboardOutlined,
    // url: "/companies",

    children: [
      {
        id: "companies",
        title: <FormattedMessage id="Companies Accounts" />,
        type: "item",
        url: "/companies-accounts",
        icon: icons.BusinessOutlinedIcon,
        breadcrumbs: false,
      },
      {
        id: "users",
        title: <FormattedMessage id="Jobseekers Accounts" />,
        type: "item",
        url: "/users",
        icon: icons.PeopleOutlinedIcon,
        breadcrumbs: false,
      },
      {
        id: "users",
        title: <FormattedMessage id="General Accounts" />,
        type: "item",
        url: "/general-users",
        icon: icons.PeopleOutlinedIcon,
        breadcrumbs: false,
      },
      {
        id: "roles",
        title: <FormattedMessage id="Roles and Permissions" />,
        type: "item",
        url: "/roles",
        icon: icons.GroupsOutlinedIcon,
        breadcrumbs: false,
      },
    ],
  };

  return userItems;
};

export default userManagmentItems;
